import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './SummaryRow.scss';

interface IOwnProps {
  label: string;
  value: string;
  total?: boolean;
  variant?: 'small' | 'smaller';
}

const SummaryRow: React.SFC<IOwnProps> = ({ label, value, total, variant }) => {
  const rowClassNames = cx({
    [Styles.row]: true,
    [Styles.total]: total,
    [Styles.small]: variant === 'small',
    [Styles.smaller]: variant === 'smaller'
  });

  return (
    <div className={rowClassNames}>
      <div className={Styles.label}>{label}</div>
      <div className={Styles.value}>{value}</div>
    </div>
  );
};

export default SummaryRow;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/SummaryRow/SummaryRow.tsx